


export const treeSelectionSiteMutations = {
    SET_TREE_SELECTED_SITES_FLEET: (state, payload) => {
        state.treeSelectedSitesFleet = payload;
    }
};
